import constantes from '../helpers/constanteHelper'

function Divisor({ resolucaoMobile }) {
    return (
        <div style={{ cursor: 'pointer', width: ' 90vw', height: '1px', background: constantes.CORES.BRANCO_PADRAO }}>
            
        </div>
    );
}
export default Divisor;
